import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, User, Moon, Sun, Globe, Bell } from 'lucide-react';
import { useProgress } from '../context/ProgressContext';
export function ProfilePage() {
  const navigate = useNavigate();
  const {
    progress,
    updatePreferences
  } = useProgress();
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(progress.preferences.name);
  const handleSaveName = () => {
    updatePreferences({
      name: editedName
    });
    setIsEditing(false);
  };
  const toggleTheme = () => {
    const newTheme = progress.preferences.theme === 'light' ? 'dark' : 'light';
    updatePreferences({
      theme: newTheme
    });
  };
  return <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-blue-50 to-teal-50 dark:from-slate-900 dark:via-blue-950 dark:to-teal-950 pb-20 md:pb-8" data-id="element-801">
      <header className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-b border-blue-100 dark:border-slate-700 sticky top-0 z-10" data-id="element-802">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-803">
          <button onClick={() => navigate('/home')} className="flex items-center space-x-2 text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300" data-id="element-804">
            <ArrowLeft className="w-5 h-5" data-id="element-805" />
            <span className="font-medium" data-id="element-806">Home</span>
          </button>
          <h1 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-807">
            Profile
          </h1>
          <div className="w-20" data-id="element-808" />
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-4 py-8" data-id="element-809">
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg p-8 mb-6" data-id="element-810">
          <div className="flex items-center space-x-4 mb-6" data-id="element-811">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center" data-id="element-812">
              <User className="w-10 h-10 text-white" data-id="element-813" />
            </div>
            <div className="flex-1" data-id="element-814">
              {isEditing ? <div className="flex items-center space-x-2" data-id="element-815">
                  <input type="text" value={editedName} onChange={e => setEditedName(e.target.value)} className="px-3 py-2 border-2 border-blue-300 dark:border-blue-600 rounded-lg dark:bg-slate-700 dark:text-white" placeholder="Your name" data-id="element-816" />
                  <button onClick={handleSaveName} className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600" data-id="element-817">
                    Save
                  </button>
                  <button onClick={() => {
                setEditedName(progress.preferences.name);
                setIsEditing(false);
              }} className="px-4 py-2 bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-slate-600" data-id="element-818">
                    Cancel
                  </button>
                </div> : <>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-819">
                    {progress.preferences.name || 'Anonymous User'}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-400" data-id="element-820">
                    {progress.preferences.pronouns} • Age{' '}
                    {progress.preferences.age}
                  </p>
                  <button onClick={() => setIsEditing(true)} className="text-sm text-blue-600 dark:text-blue-400 hover:underline mt-1" data-id="element-821">
                    Edit Name
                  </button>
                </>}
            </div>
          </div>
          <div className="space-y-4" data-id="element-822">
            <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-slate-700 rounded-xl" data-id="element-823">
              <div className="flex items-center space-x-3" data-id="element-824">
                {progress.preferences.theme === 'light' ? <Sun className="w-5 h-5 text-yellow-500" data-id="element-825" /> : <Moon className="w-5 h-5 text-blue-400" data-id="element-826" />}
                <div data-id="element-827">
                  <p className="font-semibold text-gray-900 dark:text-white" data-id="element-828">
                    Theme
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-829">
                    {progress.preferences.theme === 'light' ? 'Light Mode' : 'Dark Mode'}
                  </p>
                </div>
              </div>
              <button onClick={toggleTheme} className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors" data-id="element-830">
                Switch
              </button>
            </div>
            <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-slate-700 rounded-xl" data-id="element-831">
              <div className="flex items-center space-x-3" data-id="element-832">
                <Globe className="w-5 h-5 text-green-500" data-id="element-833" />
                <div data-id="element-834">
                  <p className="font-semibold text-gray-900 dark:text-white" data-id="element-835">
                    Language
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-836">
                    English
                  </p>
                </div>
              </div>
            </div>
            <div className="p-4 bg-blue-50 dark:bg-slate-700 border-l-4 border-blue-500 rounded-lg" data-id="element-837">
              <p className="text-sm text-blue-900 dark:text-blue-200" data-id="element-838">
                <strong data-id="element-839">Privacy:</strong> Your data is stored locally on your
                device. We don't track your identity or share your information
                with anyone.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg p-8" data-id="element-840">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-841">
            Your Stats
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-842">
            <div className="text-center p-4 bg-blue-50 dark:bg-slate-700 rounded-xl" data-id="element-843">
              <p className="text-3xl font-bold text-blue-600 dark:text-blue-400" data-id="element-844">
                {progress.points}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-845">Points</p>
            </div>
            <div className="text-center p-4 bg-teal-50 dark:bg-slate-700 rounded-xl" data-id="element-846">
              <p className="text-3xl font-bold text-teal-600 dark:text-teal-400" data-id="element-847">
                {progress.streak}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-848">
                Day Streak
              </p>
            </div>
            <div className="text-center p-4 bg-green-50 dark:bg-slate-700 rounded-xl" data-id="element-849">
              <p className="text-3xl font-bold text-green-600 dark:text-green-400" data-id="element-850">
                {progress.badges.filter(b => b.earned).length}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-851">Badges</p>
            </div>
            <div className="text-center p-4 bg-purple-50 dark:bg-slate-700 rounded-xl" data-id="element-852">
              <p className="text-3xl font-bold text-purple-600 dark:text-purple-400" data-id="element-853">
                {progress.completedStories.length}
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-854">
                Stories
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}